import { render, staticRenderFns } from "./AddSaturdayWorkingDays.vue?vue&type=template&id=8a5f357c&scoped=true"
import script from "./AddSaturdayWorkingDays.vue?vue&type=script&lang=js"
export * from "./AddSaturdayWorkingDays.vue?vue&type=script&lang=js"
import style0 from "./AddSaturdayWorkingDays.vue?vue&type=style&index=0&id=8a5f357c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5f357c",
  null
  
)

export default component.exports